/*
 * @Author: Json Chen
 * @Date: 2021-07-19 12:18:17
 * @LastEditTime: 2022-06-01 16:23:06
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/PackingSlip/index.tsx
 */

import { Button } from '@/src/components/Antd';
import { getPackingSlip2 } from '@/src/request/settings/logistics/packingslip';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import styles from './style.module.less';

const permissions = () => {
  const customise_packing_slip = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation: EnumOperation.customise_packing_slip,
      }),
    ],
  });
  const preview_test_packing_slip = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsWarehouse,
        operation: EnumOperation.preview_test_packing_slip,
      }),
    ],
  });
  return {
    preview_test_packing_slip,
    customise_packing_slip,
  };
};

const PackingSlip = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { preview_test_packing_slip, customise_packing_slip } = permissions();
  const [slipSize, setSlipSize] = useState('');
  const history = useHistory();
  const params: any = useParams();
  const { uuid: warehouseUuid } = params;
  useEffect(() => {
    getPackingSlip2(warehouseUuid).then((data) => {
      setSlipSize(data.slipSize);
    });
  }, []);

  const onCustomClick = () => {
    history.push(`/settings/logistics/packingslip/setting/${warehouseUuid}`);
  };

  return (
    <div
      className={`${styles.logisticsItemContainer} ${styles.packingSlipContainer}`}>
      <Spin spinning={false}>
        <div className={styles.norConfig}>
          <div className={styles.title}>
            {slipSize == 'A5'
              ? `A5 ${replaceI18nVariables(
                  getI18n('general.upload.EditModal.size'),
                  '(148 x 210mm)',
                )}`
              : `A4 ${replaceI18nVariables(
                  getI18n('general.upload.EditModal.size'),
                  '(210 x 297mm)',
                )}`}
          </div>
          <div className={styles.description}>
            {getI18n('storeLogistics.packingSlip.packingSlipIndexDescription')}
          </div>
        </div>
        <div className={styles.buttons}>
          <Button
            type='primary'
            disabled={!customise_packing_slip}
            className={styles.button}
            onClick={onCustomClick}>
            {getI18n('storeLogistics.packingSlip.packingSlipIndexCustomise')}
          </Button>
          <Button
            className={styles.button}
            disabled={!preview_test_packing_slip}>
            {getI18n('storeLogistics.packingSlip.printTestPackingSlip')}
          </Button>
        </div>
      </Spin>
    </div>
  );
};

export default PackingSlip;
